import { TableRow } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "../styles";
import { FleetData } from "types/DaAndFleet";
import { FLEET_TABLE_HEADERS_COLUMN } from "../tableData";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FleetStatusCell } from "./FleetStatusCell";
import useResize from "hooks/useResize";

interface FleetReportRowProps {
  row: FleetData;
  tableNumber?: number;
}

export const FleetStatusRow: FC<FleetReportRowProps> = ({ row, tableNumber }) => {
  const classes = useStyles();
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    fleetData: { fleetListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);

  return (
    <TableRow
      key={`${row.number}`}
      className={idListForUpdate.includes(row.id) ? classes.activeRow : ""}
    >
      {FLEET_TABLE_HEADERS_COLUMN.filter((col) =>
        width > 840
          ? col.table === tableNumber
          : tableNumber === 1
            ? ["checkbox"].includes(col.id)
            : !["checkbox"].includes(col.id) || ["number"].includes(col.id),
      )
        ?.filter((col: any) =>
          fleetListFilters?.activeColumns?.length
            ? width > 840
              ? fleetListFilters?.activeColumns?.includes(col.id) ||
                ["checkbox", "number"].includes(col.id)
              : fleetListFilters?.activeColumns?.includes(col.id) || ["checkbox"].includes(col.id)
            : true,
        )
        .map((item) =>
          FleetStatusCell(
            item.id,
            row,
            classes,
            userData.station_spots.find(
              (spot) => item.id === "station" && spot.station.id === row.station,
            )?.station.title,
            userData.role,
          ),
        )}
    </TableRow>
  );
};
